export default "__VITE_ASSET__CgE$Kz$1__"